// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2YHVL","tab":"ProcedureTabs_tab__3uzaK"};